import React from 'react';
import { SignIn as ClerkSignIn } from '@clerk/clerk-react';
import './Auth.scss';

export const SignIn: React.FC = () => {
  return (
    <div className="auth-container">
      <div className="auth-header">
        <h1>Welcome to Flowcus</h1>
        <p>Your AI-powered ADHD assistant</p>
      </div>
      <div className="auth-form">
        <ClerkSignIn 
          routing="hash"
          appearance={{
            elements: {
              rootBox: 'auth-clerk-root',
              card: 'auth-clerk-card',
            }
          }}
        />
      </div>
    </div>
  );
};